import React from 'react';

import { User } from '@front/common/src/types/commons';
import { CommonModalProps } from '@front/common/src/types/components';
import { isSpotCleaningSelector } from '@front/common/src/ducks/customer/basket';
import { getBasketDuration } from '@front/common/src/ducks/customer/basket-selectors';

import { MembershipOptIn } from '@front/customer/src/modals/membership-paywall/utils';

import FullHeightCenteredModal from '@front/web-ui/src/components/modal/full-height-centered-modal';

import { useAppSelector } from '../../../store';

import RecurringContent from './recurring-content';
import SpotContent from './spot-content';

type CleaningMembershipPaywallProps = {
  isOpen: CommonModalProps['isOpen'];
  optInChoice?: MembershipOptIn;
  user?: User;
  closePaywall?: () => void;
  onConfirmPaywall: () => void;
  onOptInChoiceSelection: (newOptInChoice: MembershipOptIn) => void;
};

const CleaningMembershipPaywall = ({
  isOpen,
  optInChoice,
  user,
  onConfirmPaywall,
  closePaywall,
  onOptInChoiceSelection,
}: CleaningMembershipPaywallProps) => {
  const isSpotCleaning = useAppSelector(isSpotCleaningSelector);
  const duration = useAppSelector(getBasketDuration);

  return (
    <FullHeightCenteredModal isOpen={isOpen} onClose={closePaywall}>
      {isSpotCleaning ? (
        <SpotContent
          duration={duration}
          optInChoice={optInChoice}
          user={user}
          onConfirmPaywall={onConfirmPaywall}
          onOptInChoiceSelection={onOptInChoiceSelection}
        />
      ) : (
        <RecurringContent user={user} closePaywall={closePaywall} />
      )}
    </FullHeightCenteredModal>
  );
};

export default CleaningMembershipPaywall;
